module.exports = __webpack_public_path__ + "static/demoscreen1test2-7f9e8594e7fde317af6a28c5797551a1.png";